var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var Main = (function () {
      
      var initialized;
      var animations;

      function Main(anims) {
        animations = anims;
        this.timeline = new TimelineMax({ paused: true });
        this.scrollHeight;
        this.duration = 0;
        this.keyframes = {};
      }
      
      Main.prototype.handleWindowResize = function (bodyWidth, bodyHeight) {
        var previousProgress = this.timeline.progress();
        
        this.timeline.clear();

        animations.scrollSpeed = animations.isTouchDevice ? 1 : .7;
        
        // Precompute heights and timings
        var currentTime = 0;

        var ease = Linear.easeNone;
        var force3D = true;
        var enterAnimsAnticipation = .6;

        var floatingMenuTime = 63 / bodyHeight;

        var openingHeight = 880;
        var openingTime = openingHeight / bodyHeight;

        var domain1 = $('#domain-1');
        var domain1Height = openingHeight + $('#domain-who').innerHeight();
        var domain1Time = domain1Height / bodyHeight;

        var totalHeight = domain1Height;

        this.timeline.fromTo(domain1, domain1Time, {
          y: 0,
        }, {
          y: -domain1Height,
          force3D: force3D,
          ease: ease
        }, 0);
        this.timeline.fromTo(domain1, .0001, {
          display: 'block'
        }, {
          display: 'none',
        }, domain1Time);

        this.keyframes.home = 0;
        this.keyframes['domain-presentation'] = openingTime;

        // home parallax
        this.timeline.fromTo('#domain-intro', openingTime, {
          y: 30
        }, {
          y: -70,
          ease: ease
        }, 0);

        this.timeline.call(window.app.menu.toggleFloating, null, null, openingTime - floatingMenuTime);

        // domain-presentation parallax
        this.timeline
        .fromTo('#domain-who-img-wrapper', 1.5, {
          y: 150
        }, {
          y: -150,
          ease: ease
        }, openingTime - .5)
        .fromTo('#domain-who-img', 2, {
          y: -210
        }, {
          y: 0,
          ease: ease
        }, openingTime - 1);

        this.timeline.call(
          animations.sequences.domain.presentationEnterAnimation,
          null,
          animations.sequences.domain,
          currentTime + openingTime - enterAnimsAnticipation);

        currentTime += domain1Time;
        this.keyframes['domain-philosophy'] = currentTime;

        this.timeline
        .fromTo('#domain-who-foreground', 1.25, {
          y: 100
        }, {
          y: -150,
          ease: ease
        }, currentTime - 785 / bodyHeight - .33)
        .fromTo('#domain-who-background', 2, {
          y: -100
        }, {
          y: 100,
          ease: ease
        }, currentTime - 785 / bodyHeight - 1);

        var domain2 = $('#domain-what');
        var domain2Height = domain2.innerHeight();
        var domain2Time = domain2Height / bodyHeight;

        totalHeight += domain2Height;

        // domain-philosophy parallax
        this.timeline
        .fromTo('#domain-what-img-wrapper', 2, {
          y: 100
        }, {
          y: -100,
          ease: ease
        }, currentTime + 287 / bodyHeight - 1.1)
        .fromTo('#domain-what-img', 2, {
          y: -210
        }, {
          y: 0,
          ease: ease
        }, currentTime + 287 / bodyHeight - .8)
        .fromTo('#domain-what-img1', 2, {
          y: 200
        }, {
          y: -200,
          ease: ease
        }, currentTime + 600 / bodyHeight - .9)
        .fromTo('#domain-what-img2', 2, {
          y: 300
        }, {
          y: -300,
          ease: ease
        }, currentTime + 1035 / bodyHeight - 1.2)
        .fromTo('#domain-what-img3', 2, {
          y: 400
        }, {
          y: -400,
          ease: ease
        }, currentTime + 1315 / bodyHeight - 1.2);

        this.timeline.fromTo(domain2, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(domain2, domain2Time + 1, {
          y: bodyHeight,
        }, {
          y: -domain2Height,
          force3D: force3D,
          ease: ease
        }, currentTime - 1);
        this.timeline.fromTo(domain2, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + domain2Time);

        this.timeline.call(
          animations.sequences.domain.presentationClosingEnterAnimation,
          null,
          animations.sequences.domain,
          currentTime - 800 / bodyHeight - enterAnimsAnticipation);

        this.timeline.call(
          animations.sequences.domain.philosophyEnterAnimation,
          null,
          animations.sequences.domain,
          currentTime - enterAnimsAnticipation);

        this.timeline.call(
          animations.sequences.domain.philosophyTextEnterAnimation,
          null,
          animations.sequences.domain,
          currentTime + 900 / bodyHeight - enterAnimsAnticipation);

        currentTime += domain2Time;

        this.keyframes['savoir-faire-viticulture'] = currentTime;

        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime - floatingMenuTime);
        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime + openingTime);

        this.timeline.call(
          animations.sequences['savoir-faire'].mastEnterAnimation,
          null,
          animations.sequences['savoir-faire'],
          currentTime - enterAnimsAnticipation);

        var savoirFaire1 = $('#savoir-faire-1');
        var savoirFaire1Height = openingHeight + $('#viticulture').innerHeight();
        var savoirFaire1Time = savoirFaire1Height / bodyHeight;

        this.timeline.call(
          animations.sequences['savoir-faire'].viticultureEnterAnimation,
          null,
          animations.sequences.domain,
          currentTime + openingTime - enterAnimsAnticipation);

        totalHeight += savoirFaire1Height;

        this.timeline.fromTo(savoirFaire1, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(savoirFaire1, savoirFaire1Time + 1, {
          y: bodyHeight
        }, {
          y: -savoirFaire1Height,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);
        this.timeline.fromTo(savoirFaire1, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + savoirFaire1Time);

        // Savoir-faire - viticulture - parallax
        this.timeline
        .fromTo('#viticulture-img-wrapper', 1.5, {
          y: 150
        }, {
          y: -150,
          ease: ease
        }, currentTime + openingTime - .7)
        .fromTo('#viticulture-img', 2, {
          y: -210
        }, {
          y: 0,
          ease: ease
        }, currentTime + openingTime - 1);

        this.timeline
        .fromTo('#viticulture-button-gallery, #viticulture-line', 2, {
          y: 200
        }, {
          y: -200,
          ease: ease
        }, currentTime + (1164 / bodyHeight) + openingTime - 1.25)
        .fromTo('#viticulture-closing-img1', 2, {
          y: -100
        }, {
          y: 100,
          ease: ease
        }, currentTime + (1164 / bodyHeight) + openingTime - 1.25);

        currentTime += savoirFaire1Time;

        this.timeline.call(
          animations.sequences['savoir-faire'].viticultureClosingAnimation,
          null,
          animations.sequences.domain,
          currentTime - (774 / bodyHeight) - enterAnimsAnticipation);

        this.keyframes['savoir-faire-vinification'] = currentTime;

        this.timeline.call(
          animations.sequences['savoir-faire'].vinificationEnterAnimation,
          null,
          animations.sequences['savoir-faire'],
          currentTime - enterAnimsAnticipation);

        this.timeline.call(
          animations.sequences['savoir-faire'].vinificationTextAnimation,
          null,
          animations.sequences['savoir-faire'],
          currentTime + (800 / bodyHeight) - enterAnimsAnticipation);

        var savoirFaire2 = $('#vinification');
        var savoirFaire2Height = savoirFaire2.innerHeight();
        var savoirFaire2Time = savoirFaire2Height / bodyHeight;

        totalHeight += savoirFaire2Height;

        this.timeline.fromTo(savoirFaire2, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(savoirFaire2, savoirFaire2Time + 1, {
          y: bodyHeight
        }, {
          y: -savoirFaire2Height,
          force3D: force3D,
          ease: ease
        }, currentTime - 1);
        this.timeline.fromTo(savoirFaire2, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + savoirFaire2Time);

        // Savoir-faire - vinification - parallax
        this.timeline
        .fromTo('#vinification-img-wrapper', 1.5, {
          y: 50
        }, {
          y: -50,
          ease: ease
        }, currentTime - .8)
        .fromTo('#vinification-img', 2, {
          y: -210
        }, {
          y: 0,
          ease: ease
        }, currentTime - .8);

        currentTime += savoirFaire2Time;

        this.timeline
        .fromTo('.vinification-foreground', 2, {
          y: 200
        }, {
          y: -200,
          ease: ease
        }, currentTime - (850 / bodyHeight) - 1)
        .fromTo('#vinification-background', 2, {
          y: -100
        }, {
          y: 100,
          ease: ease
        }, currentTime - (850 / bodyHeight) - 1);

        this.timeline.call(
          animations.sequences['savoir-faire'].vinificationClosingAnimation,
          null,
          animations.sequences['savoir-faire'],
          currentTime - (800 / bodyHeight) - enterAnimsAnticipation);

        this.keyframes.wines = currentTime;

        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime -floatingMenuTime);
        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime + openingTime);

        this.timeline.call(
          animations.sequences.wines.mastEnterAnimation,
          null,
          animations.sequences.wines,
          currentTime - enterAnimsAnticipation);

        var wines1 = $('#wines-1');
        var wines1Height = openingHeight + $('#wines-intro').innerHeight();
        var wines1Time = wines1Height / bodyHeight;

        totalHeight += wines1Height;

        this.timeline.call(
          animations.sequences.wines.textEnterAnimation,
          null,
          animations.sequences.wines,
          currentTime + openingTime - enterAnimsAnticipation);

        this.timeline.fromTo(wines1, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(wines1, wines1Time + 1, {
          y: bodyHeight
        }, {
          y: -wines1Height,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);
        this.timeline.fromTo(wines1, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + wines1Time);

        // wines parallax
        this.timeline
        .fromTo('#wines-img2', 2, {
          y: 100
        }, {
          y: -100,
          ease: ease
        }, currentTime + openingTime - .8);

        currentTime += wines1Time;

        this.keyframes['wine-list'] = currentTime;

        this.timeline.call(
          animations.sequences.wines.listEnterAnimation,
          null,
          animations.sequences.wines,
          currentTime - enterAnimsAnticipation);

        var wines2 = $('#wines-2');
        var wines2Height = wines2.innerHeight();
        var wines2Time = wines2Height / bodyHeight;

        totalHeight += wines2Height;

        this.timeline.fromTo(wines2, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(wines2, wines2Time + 1, {
          y: bodyHeight
        }, {
          y: -wines2Height,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);
        this.timeline.fromTo(wines2, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + wines2Time);

        // wines list parallax
        this.timeline
        .fromTo('#wines-img5', 2, {
          y: 200
        }, {
          y: -200,
          ease: ease
        }, currentTime + (300 / bodyHeight) - 1.3)
        .fromTo('#wines-img4', 2, {
          y: -100
        }, {
          y: 100,
          ease: ease
        }, currentTime + (850 / bodyHeight) - 1.3);

        currentTime += wines2Time;

        this.timeline
        .fromTo('#wines-img6-wrapper', 1.5, {
          y: 50
        }, {
          y: -50,
          ease: ease
        }, currentTime - (750 / bodyHeight) - .8)
        .fromTo('#wines-img6', 2, {
          y: -142
        }, {
          y: 0,
          ease: ease
        }, currentTime - (750 / bodyHeight) - .8);

        this.timeline.call(
          animations.sequences.wines.closingAnimation,
          null,
          animations.sequences.wines,
          currentTime - (900 / bodyHeight) - enterAnimsAnticipation);

        this.keyframes.vintages = currentTime;

        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime - floatingMenuTime);
        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime + openingTime);

        this.timeline.call(
          animations.sequences.vintages.mastEnterAnimation,
          null,
          animations.sequences.vintages,
          currentTime - enterAnimsAnticipation);

        this.timeline.call(
          animations.sequences.vintages.mainEnterAnimation,
          null,
          animations.sequences.vintages,
          currentTime + openingTime - enterAnimsAnticipation);

        var vintages = $('#vintages');
        var vintagesHeight = openingHeight + $('#vintages-list').innerHeight();
        var vintagesTime = vintagesHeight / bodyHeight;

        totalHeight += vintagesHeight;

        this.timeline.fromTo(vintages, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(vintages, vintagesTime + 1, {
          y: bodyHeight
        }, {
          y: -vintagesHeight,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);
        this.timeline.fromTo(vintages, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + vintagesTime);

        // Vintages parallax
        this.timeline
        .fromTo('#vintages-img3, .vintage-intro:nth-child(3n+2)', 2, {
          y: 100
        }, {
          y: -100,
          ease: ease
        }, currentTime + openingTime - 1);

        currentTime += vintagesTime;

        this.keyframes.distributors = currentTime;

        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime - floatingMenuTime);
        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime + openingTime);

        this.timeline.call(
          animations.sequences.distributors.mastEnterAnimation,
          null,
          animations.sequences.distributors,
          currentTime - enterAnimsAnticipation);

          this.timeline.call(
          animations.sequences.distributors.mainEnterAnimation,
          null,
          animations.sequences.distributors,
          currentTime + openingTime - enterAnimsAnticipation);

        var distributors = $('#distributors');
        var distributorsHeight = distributors.innerHeight();
        var distributorsTime = distributorsHeight / bodyHeight;

        totalHeight += distributorsHeight;

        this.timeline.fromTo(distributors, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(distributors, distributorsTime + 1, {
          y: bodyHeight
        }, {
          y: -distributorsHeight,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);
        this.timeline.fromTo(distributors, .0001, {
          display: 'block'
        }, {
          display: 'none',
          immediateRender: false
        }, currentTime + distributorsTime);

        // distributors parallax
        this.timeline
        .fromTo('#distributors-foreground', 2, {
          y: 100
        }, {
          y: -100,
          ease: ease
        }, currentTime + openingTime - .8)
        .fromTo('#distributors-background', 2, {
          y: -50
        }, {
          y: 50,
          ease: ease
        }, currentTime + openingTime - .8);

        currentTime += distributorsTime;

        this.keyframes.contact = currentTime;

        this.timeline.call(window.app.menu.toggleFloating, null, null, currentTime - floatingMenuTime);

        this.timeline.call(
          animations.sequences.contact.mastEnterAnimation,
          null,
          animations.sequences.contact,
          currentTime - enterAnimsAnticipation);

        var contact = $('#contact');
        var contactTime = openingTime;

        totalHeight += openingHeight;

        this.timeline.fromTo(contact, .0001, {
          display: 'none'
        }, {
          display: 'block'
        }, currentTime - 1);
        this.timeline.fromTo(contact, contactTime, {
          y: bodyHeight
        }, {
          y: -openingHeight + bodyHeight,
          force3D: force3D,
          ease: ease,
          immediateRender: false
        }, currentTime - 1);

        currentTime += contactTime - 2;

        this.duration = this.timeline.totalDuration();
        this.scrollHeight = totalHeight;

        if (!initialized) {
          this.timeline.progress(previousProgress);
          this.timeline.invalidate();
          initialized = true;
        } else {
          this.timeline.invalidate();
          this.timeline.progress(previousProgress);
        }

      };

      Main.prototype.setTime = function (time, duration, ease) {
        var safeTime = Math.min(Math.max(time, 0), this.duration);

        TweenMax.killTweensOf(this.timeline);
        if (duration === undefined || duration === null || duration === 0) {
          this.timeline.time(safeTime);
        } else {
          TweenMax.to(this.timeline, duration, { time: safeTime, ease: ease });
        }
      }

      Main.prototype.getTime = function() {
        return this.timeline.time() || 0;
      }

      return Main;
    })();

    Sequences.Main = Main;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));